import React from 'react';

export function ThreeDotsSpinner({ className = '' }: { className?: string }) {
  return (
    <div className={`w-[50px] opacity-50 flex gap-[10px] justify-center items-center ${className}`}>
      <div className='w-[10px] h-[10px] bg-[var(--color-primary)] rounded-full animate-scale-pulse [animation-delay:-0.3s]' />
      <div className='w-[10px] h-[10px] bg-[var(--color-primary)] rounded-full animate-scale-pulse [animation-delay:-0.15s]' />
      <div className='w-[10px] h-[10px] bg-[var(--color-primary)] rounded-full animate-scale-pulse' />
    </div>
  );
}
